import { render, staticRenderFns } from "./StakeholderIndex.vue?vue&type=template&id=a3aa62d0&"
import script from "./StakeholderIndex.vue?vue&type=script&lang=js&"
export * from "./StakeholderIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports